<template>
    <ubi-page-container>

        <!--DEBUT : SFC-->
        <ubi-panel>
            <h1>{{ $t("website.title") }}</h1>
            <div style="margin-left: 4%; margin-right: 4%; font-size: 130%;">
                <p class="text-justify">{{ $t("website.functionalityNoActivated") }}</p>
            </div>
            <br><br>
            <div class="text-center">
                <el-button type="primary">
                    <a href="#contact" id="lienBouton" >{{ $t("website.contactUs") }}</a>
                </el-button>
            </div>

            <script type="text/x-template" id="modal-template">
              <transition name="modal">
                <div class="modal-mask">
                  <div class="modal-wrapper">
                    <div class="modal-container">

                      <div class="modal-header">
                        <slot name="header">
                          default header
                        </slot>
                      </div>

                      <div class="modal-body">
                        <slot name="body">
                          default body
                        </slot>
                      </div>

                      <div class="modal-footer">
                        <slot name="footer">
                          default footer
                          <button class="modal-default-button" @click="$emit('close')">
                            OK
                          </button>
                        </slot>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </script>

        </ubi-panel>
        <!--FIN : SFC-->
    </ubi-page-container>
</template>

<script>
export default {
  name: 'monSiteInternet',
  components: {},
  data () {
    return {}
  }
}
</script>
<style>
    #lienBouton{
        color: white;
        text-decoration: none;
    }
</style>
